export const AirPressure = () => (
  <svg
    width="44"
    height="33"
    viewBox="0 0 44 33"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <filter
        x="-11.6%"
        y="-9.3%"
        width="123.2%"
        height="137.3%"
        filterUnits="objectBoundingBox"
        id="jcjc5aju7a"
      >
        <feOffset dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" in="shadowBlurOuter1" />
      </filter>
      <path
        d="M24.63 8.473a4.24 4.24 0 0 1 4.239 4.237 4.237 4.237 0 0 1-4.238 4.236H4.148a.706.706 0 1 1 0-1.412H24.63a2.827 2.827 0 0 0 2.825-2.824 2.825 2.825 0 0 0-5.65 0v.706a.706.706 0 0 1-1.413 0v-.706a4.237 4.237 0 0 1 4.238-4.237zM14.42 0v4.742h4.071l-6.327 8.674-6.328-8.674h4.072V0h4.512zm20.1 18.359a4.24 4.24 0 0 1 4.238 4.236 4.237 4.237 0 0 1-8.476 0v-.706a.706.706 0 0 1 1.413 0v.706a2.825 2.825 0 1 0 2.825-2.824H10.505a.706.706 0 1 1 0-1.412zm-16.16 2.824a.706.706 0 1 1 0 1.412h-6.357a.706.706 0 1 1 0-1.412zm7.292 0a.706.706 0 1 1 0 1.412h-2.885a.706.706 0 1 1 0-1.412zM7.2 19.065a.706.706 0 0 0-.706-.706H2.78a.706.706 0 1 0 0 1.412h3.713a.707.707 0 0 0 .706-.706zm1.187 2.118H.706a.706.706 0 1 0 0 1.412h7.68a.706.706 0 1 0 0-1.412z"
        id="3uhntcd73b"
      />
    </defs>
    <g transform="translate(2.956 .919)" fillRule="nonzero" fill="none">
      <use fill="#000" filter="url(#jcjc5aju7a)" xlinkHref="#3uhntcd73b" />
      <use fill="#FFF" xlinkHref="#3uhntcd73b" />
    </g>
  </svg>
);
